import React from 'react';
import { ArrowRight, ShieldCheck, Download } from 'lucide-react';
export function FinalCTASection() {
  return <section id="precio" className="py-20 bg-[#3D4852] text-white relative overflow-hidden" data-id="element-11">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-12">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-[#C17F6B] rounded-full blur-3xl" data-id="element-13"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#8B9A7D] rounded-full blur-3xl" data-id="element-14"></div>
      </div>

      <div className="container mx-auto px-4 max-w-4xl text-center relative z-10" data-id="element-15">
        <h2 className="text-4xl lg:text-5xl font-serif font-bold mb-6" data-id="element-16">
          Recupera el control en 21 días
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-17">
          Sin dietas extremas. Sin pasar hambre. Con un sistema que entiende tu
          cuerpo de 45+.
        </p>

        <div className="bg-white text-[#3D4852] p-8 rounded-3xl shadow-2xl max-w-lg mx-auto mb-10 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-18">
          {/* Special discount badge */}
          <div className="bg-[#C17F6B] text-white text-sm font-bold px-4 py-2 rounded-full inline-block mb-4" data-id="element-19">
            🔥 ¡OFERTA ESPECIAL!
          </div>

          <div className="flex justify-center items-baseline gap-3 mb-1" data-id="element-20">
            <span className="text-5xl font-bold text-[#C17F6B]" data-id="element-21">$6.39</span>
            <span className="text-xl text-gray-400 line-through" data-id="element-22">$27 USD</span>
          </div>
          <p className="text-xs text-[#8B9A7D] font-semibold mb-4" data-id="element-23">
            Ahorra 76% — Precio original:{' '}
            <span className="line-through" data-id="element-24">$47 USD</span>
          </p>
          <p className="text-sm text-gray-500 mb-6" data-id="element-25">
            Pago único • Acceso de por vida
          </p>

          <ul className="text-left space-y-3 mb-8 bg-gray-50 p-6 rounded-xl" data-id="element-26">
            <li className="flex items-center gap-2" data-id="element-27">
              <Download className="w-4 h-4 text-[#8B9A7D]" data-id="element-28" />
              <span className="font-medium" data-id="element-29">Ebook Completo (PDF)</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-30">
              <Download className="w-4 h-4 text-[#8B9A7D]" data-id="element-31" />
              <span className="font-medium" data-id="element-32">Plan de 21 Días</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-33">
              <Download className="w-4 h-4 text-[#8B9A7D]" data-id="element-34" />
              <span className="font-medium" data-id="element-35">Todos los Bonos de Regalo</span>
            </li>
          </ul>

          <a href="https://sinlimit.com//cart/48010327884003:1" target="_blank" rel="noopener noreferrer" className="w-full px-8 py-4 bg-[#C17F6B] hover:bg-[#A96B58] text-white text-lg font-bold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2" data-id="element-36">
            Descargar Ahora
            <ArrowRight className="w-5 h-5" data-id="element-37" />
          </a>

          <div className="mt-4 flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-38">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-39" />
            <span data-id="element-40">Compra 100% Segura</span>
          </div>
        </div>

        <p className="text-xs text-gray-500 max-w-2xl mx-auto opacity-60" data-id="element-41">
          Descargo de responsabilidad: Este producto es material educativo y no
          reemplaza el consejo médico profesional. Los resultados pueden variar
          según cada persona. Consulta a tu médico antes de iniciar cambios en
          tu dieta o ejercicio.
        </p>
      </div>
    </section>;
}